class CompareNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('compare-notification');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification?.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this)),
    );
  }

  open() {
    const compareBar = document.querySelector('.product-comparison-bar.is-visible');
    const isMobile = window.innerWidth <= 749;

    if (compareBar) {
      const barHeight = compareBar.offsetHeight;
      const baseOffset = isMobile ? '1rem' : '2rem';
      this.notification.style.bottom = `calc(${baseOffset} + ${barHeight}px)`;
    } else {
      this.notification.style.bottom = isMobile ? '1rem' : '2rem';
    }

    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true },
    );

    document.body.addEventListener('click', this.onBodyClick);

    setTimeout(() => {
      this.close();
    }, 5000);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('compare-notification')) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('compare-notification', CompareNotification);
